import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import PollingDevice from "@/pages/PollingDevice";
import AdminPortal from "@/pages/AdminPortal";
import OperatorCompanion from "@/pages/OperatorCompanion";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/polling" element={<PollingDevice />} />
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="/admin/:tab" element={<AdminPortal />} />
          <Route path="/operator" element={<OperatorCompanion />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
